import React from 'react';

import {
  GetClientLiteResult,
  useGetClientLite,
} from '../data/useGetClientLite';
import {
  GetJobLinkDetailsResult,
  useGetJobLinkDetails,
} from '../data/useGetJobLinkDetails';

type JobLink = {
  job: GetJobLinkDetailsResult;
  client: GetClientLiteResult;
};

export const useQueryJobLink = (
  jobCloudId: string
): {
  loading?: boolean;
  error?: boolean;
  data?: JobLink;
} => {
  const jobLink = useGetJobLinkDetails({ variables: { cloudId: jobCloudId } });
  const clientLite = useGetClientLite({
    variables: {
      cloudId: jobLink.data?.clientId ?? '',
    },
    skip: Boolean(!jobLink.data),
  });

  return React.useMemo(() => {
    if (jobLink.loading || clientLite.loading) {
      return { loading: true };
    }
    if (
      jobLink.error ||
      clientLite.error ||
      !jobLink.data ||
      !clientLite.data
    ) {
      return { error: true };
    }

    const data: JobLink = {
      job: jobLink.data,
      client: clientLite.data,
    };

    return { data };
  }, [jobLink, clientLite]);
};
